"use client";

import { useEffect } from "react";
import { createClient } from "@/utils/supabase/client";
import { useRouter } from "next/navigation";

/**
 * Supabase セッションの期限切れ・エラーを監視してログアウトにリダイレクトする。
 */
export function useSessionErrorHandler() {
  const router = useRouter();

  useEffect(() => {
    const supabase = createClient();
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_OUT" || event === "TOKEN_REFRESHED") {
        if (event === "SIGNED_OUT") {
          router.push("/");
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [router]);
}
